module.exports = __webpack_public_path__ + "media/images/lb/958-521a72db4a841a38510d2701edd4c034.svg";